// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gap-1 {
  gap: 0.5rem;
}

.gap-2 {
  gap: 1em;
}

p {
  font-size: 0.9rem !important;
  margin: unset !important;
}

.input-group-addon {
  cursor: pointer;
}

.btn {
  font-size: 1.5rem;
  padding-right: 3rem;
  padding-left: 3rem;
}

.voltar-login {
  display: inline-block;
  font-size: 1.2rem;
  text-decoration: underline;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.flex-column {
  flex-direction: column;
}

.common-box .panel-body {
  padding: 30px 20px 60px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/register-password/register-password.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,QAAA;AACJ;;AAEA;EACI,4BAAA;EACA,wBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,iBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ","sourcesContent":[".gap-1 {\n    gap: 0.5rem;\n}\n\n.gap-2 {\n    gap: 1em;\n}\n\np {\n    font-size: .9rem!important;\n    margin: unset!important;\n}\n\n.input-group-addon {\n    cursor: pointer;\n}\n\n.btn {\n    font-size: 1.5rem;\n    padding-right: 3rem;\n    padding-left: 3rem;\n}\n\n.voltar-login {\n    display: inline-block;\n    font-size: 1.2rem;\n    text-decoration: underline;\n}\n\n.d-flex {\n    display: flex;\n}\n\n.align-items-center {\n    align-items: center;\n}\n\n.justify-content-center {\n    justify-content: center;\n}\n\n.flex-column {\n    flex-direction: column;\n}\n\n.common-box .panel-body {\n    padding: 30px 20px 60px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
